export default "__VITE_ASSET__SNfVfBvA__"